
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'

const entityService = new EntityService()

export default Vue.extend({
  name: 'UserNew',
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: {
        required,
        maxLength: maxLength(150)
      },
      lastName: { required },
      email: {
        required,
        email
      },
      password: { required },
      type: { required }
    }
  },
  data: () => ({
    entity: 'users',
    isLoading: false,
    projects: [],
    form: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      type: 'user',
      projects: []
    },
    usersType: [
      {
        label: 'Usuario',
        value: 'user'
      },
      {
        label: 'Administrador',
        value: 'admin'
      }
    ]
  }),
  async created () {
    this.projects = await entityService.getList('projects')
  },
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        try {
          await entityService.createEntity(this.entity, this.form)
          this.$emit('input', false)
        } catch (e) {
          alert(e.message)
        }
        this.isLoading = false
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  },
  props: ['value']
})
